import React from 'react'

export default class Index extends React.Component {



  render() {

    return <div className="row">

        <div className="col-md-8 col-md-offset-2"  >
          <h1 className="" style={{marginTop:30, marginBottom:30}}>GoodsBill Application Changes</h1>
          <dl>
          <dt>3.4.72</dt>
          <dd>
                <ul>
                  <li>Multiple fixes and developements</li>
                  <li>Filters for expenses like date range, name and category</li>
                </ul>
          </dd>

          <dt>3.4.70</dt>
          <dd>
                <ul>
                  <li>New Invoice Template Amigos</li>
                </ul>
          </dd>

          <dt>3.4.70</dt>
          <dd>
                <ul>
                  <li>Purchases filter fix in report</li>
                </ul>
          </dd>
          <dt>3.4.68 & 69</dt>
          <dd>
                <ul>
                  <li>Custom Improvements and TCS for Invoices</li>
                </ul>
          </dd>

          <dt>3.4.67</dt>
          <dd>
                <ul>
                  <li>Move sez without tax sale to b2b list gstr_1</li>
                </ul>
          </dd>
          <dt>3.4.66</dt>
          <dd>
                <ul>
                  <li>Series Name as suffix</li>
                </ul>
          </dd>
          <dt>3.4.63</dt>
          <dd>
                <ul>
                  <li>Update Date filter</li>
                </ul>
          </dd>
          <dt>3.4.62</dt>
          <dd>
                <ul>
                  <li>History Chooser for invoice</li>
                </ul>
          </dd>
          <dt>3.4.61</dt>
          <dd>
                <ul>
                  <li>Cost Center Management System for Restaurants</li>
                </ul>
          </dd>
          <dt>3.4.60</dt>
          <dd>
                <ul>
                  <li>Reconsile balance amounts for both client & Supplier</li>
                  <li>Summarize at every transaction for listing efficiency</li>
                </ul>
          </dd>
          <dt>3.4.59</dt>
          <dd>
                <ul>
                  <li>Add New fields for profile</li>
                  <li>Add new invoice template</li>
                </ul>
          </dd>
          <dt>3.4.58</dt>
          <dd>
                <ul>
                  <li>Send SMS Feature</li>

                </ul>
          </dd>
            <dt>3.4.53-57</dt>
            <dd>
                  <ul>
                    <li>Multiple Updates</li>
                    <li>Invoice Mill bug fix</li>
                  </ul>
            </dd>

            <dt>3.4.52</dt>
            <dd>
                  <ul>
                    <li>Email Invoice, Share on Whatsapp </li>
                  </ul>
            </dd>
            <dt>3.4.51</dt>
            <dd>
                  <ul>
                    <li>Quantity on Invoices</li>
                    <li>Share Link on whatsapp</li>
                  </ul>
            </dd>
            <dt>3.4.50</dt>
            <dd>
                  <ul>
                    <li>Minor fixes</li>
                  </ul>
            </dd>
            <dt>3.4.49</dt>
            <dd>
                  <ul>
                    <li>Daybook Statement XLS</li>
                  </ul>
            </dd>
            <dt>3.4.48</dt>
            <dd>
                  <ul>
                    <li>Lean Percentage for specific users</li>
                  </ul>
            </dd>
            <dt>3.4.47</dt>
            <dd>
                  <ul>
                    <li>Update Taxable Price Calculation After Discount In Sale & Purchase</li>
                    <li>Support Discount In Percentages for Purchase Modern</li>
                  </ul>
            </dd>
            <dt>3.4.46</dt>
            <dd>
                  <ul>
                    <li>CPR on invoice modern entry</li>
                    <li>Support To reset CPR</li>
                    <li>Support Additonal Charges to Modern Invoice</li>
                    <li>Update Default template to support Additional Charges</li>
                  </ul>
            </dd>
            <dt>3.4.45</dt>
            <dd>
                  <ul>
                    <li>Custom Item Key Values During Invoicing</li>
                    <li>Support Trader Slim Template for the same</li>
                  </ul>
            </dd>
            <dt>3.4.44</dt>
            <dd>
                  <ul>
                    <li>Bugfix SEZ without tax</li>
                    <li>Include exempted section in GSTR Reports</li>
                  </ul>
            </dd>
            <dt>3.4.43</dt>
            <dd>
                  <ul>
                    <li>Barcode Entry Mode for Invoice and Purchase</li>
                    <li>Minor Fixes</li>
                  </ul>
            </dd>
            <dt>3.4.42</dt>
            <dd>
                  <ul>
                    <li>Improved Summary on Invoices & Purchases</li>
                  </ul>
            </dd>
            <dt>3.4.40 & 41</dt>
            <dd>
                  <ul>
                    <li>SEZ Client Invoice</li>
                    <li>Optional Rate with Tax column on default Invoice</li>
                    <li>Minor Enhancements</li>
                  </ul>
            </dd>
            <dt>3.4.39</dt>
            <dd>
                  <ul>
                    <li>UX Improvements</li>
                  </ul>
            </dd>
            <dt>3.4.38</dt>
            <dd>
                  <ul>
                    <li>Roleout history selection for all invoice previews</li>
                  </ul>
            </dd>
            <dt>3.4.38</dt>
            <dd>
                  <ul>
                    <li>New Sales XLS Download Format</li>
                    <li>Client & Supplier filter for receipts & payments</li>
                  </ul>
            </dd>
            <dt>3.4.37</dt>
            <dd>
                  <ul>
                    <li>Payments & Receipts Report</li>
                  </ul>
            </dd>
            <dt>3.4.36</dt>
            <dd>
                  <ul>
                    <li>Introduce Multi User Capability</li>
                  </ul>
            </dd>
            <dt>3.4.35</dt>
            <dd>
                  <ul>
                    <li>New Purchase XLS Download format</li>
                    <li>Date Range filter for receipts and payments</li>
                  </ul>
            </dd>
            <dt>3.4.34</dt>
            <dd>
                  <ul>
                    <li>Support Discount Percentage for Default & Modern Invoice</li>
                    <li>Table Spacing Adjustment control for Simple Invoice Letter Pad</li>
                  </ul>
            </dd>
            <dt>3.4.33</dt>
            <dd>
                  <ul>
                    <li>Additional Params for purchase and invoice</li>
                  </ul>
            </dd>
            <dt>3.4.32</dt>
            <dd>
                  <ul>
                    <li>Additional Table Options</li>
                  </ul>
            </dd>
            <dt>3.4.31</dt>
            <dd>
                  <ul>
                    <li>Fix for modern purchase entry</li>
                  </ul>
            </dd>
            <dt>3.4.30</dt>
            <dd>
                  <ul>
                    <li>Additional Params for client</li>
                  </ul>
            </dd>
            <dt>3.4.29</dt>
            <dd>
                  <ul>
                    <li>New Invoice Entry Mode and Template for Simple Services</li>
                  </ul>
            </dd>
            <dt>3.4.28</dt>
            <dd>
                  <ul>
                    <li>Add filter for invoice and purchase</li>

                  </ul>
            </dd>
            <dt>3.4.27</dt>
            <dd>
                  <ul>
                    <li>Invoice Font Style Option</li>
                    <li>Minor Enhancements and bug fixes</li>
                  </ul>
            </dd>
            <dt>3.4.26</dt>
            <dd>
                  <ul>
                    <li>Download Purchases In Excel Sheet</li>
                  </ul>
            </dd>
            <dt>3.4.25</dt>
            <dd>
                  <ul>
                    <li>Download Invoices In Excel Sheet</li>
                  </ul>
            </dd>
            <dt>3.4.24</dt>
            <dd>
                  <ul>
                    <li>Date Wise Filter on Invoices</li>
                  </ul>
            </dd>
            <dt>3.4.23</dt>
            <dd>
                  <ul>
                    <li>Counter Padding</li>
                  </ul>
            </dd>
            <dt>3.4.22</dt>
            <dd>
                  <ul>
                    <li>Provide template for general credit note</li>
                  </ul>
            </dd>
            <dt>3.4.21</dt>
            <dd>
                  <ul>
                    <li>New Purchase Entry Mode Modern</li>
                    <li>Update trader invoice to support from and to params</li>
                  </ul>
            </dd>
            <dt>3.4.20</dt>
            <dd>
                  <ul>
                    <li>Show Due info for client & supplier</li>
                  </ul>
            </dd>
            <dt>3.4.19</dt>
            <dd>
                  <ul>
                    <li>Update Modern Invoice entry Mode</li>
                  </ul>
            </dd>
            <dt>3.4.18</dt>
            <dd>
                  <ul>
                    <li>New Invoice Entry Mode</li>
                  </ul>
            </dd>
            <dt>3.4.17</dt>
            <dd>
                  <ul>
                    <li>Allow logo for Profile</li>
                  </ul>
            </dd>
            <dt>3.4.16</dt>
            <dd>
                  <ul>
                    <li>Introduce Service Items</li>
                    <li>Introduce New Invoice Entry Mode</li>
                    <li>New Template For Service</li>
                  </ul>
            </dd>
            <dt>3.4.15</dt>
            <dd>
                  <ul>
                    <li>Optional Quantity Column on Purchase</li>
                    <li>Stock Value With Tax</li>
                  </ul>
            </dd>
            <dt>3.4.14</dt>
            <dd>
                  <ul>
                    <li>Print Type Labels</li>
                  </ul>
            </dd>
            <dt>3.4.13</dt>
            <dd>
                  <ul>
                    <li>Search Through Supplier Code</li>
                  </ul>
            </dd>
            <dt>3.4.12</dt>
            <dd>
                  <ul>
                    <li>Add Jurisdiction option for invoice</li>
                  </ul>
            </dd>
            <dt>3.4.11</dt>
            <dd>
                  <ul>
                    <li>Update Invoices with purchase order</li>
                  </ul>
            </dd>
            <dt>3.4.10</dt>
            <dd>
                  <ul>
                    <li>Add Purchase Order for invoice entry</li>
                  </ul>
            </dd>
            <dt>3.4.9</dt>
            <dd>
                  <ul>
                    <li>Release New Barcode Style</li>
                  </ul>
            </dd>
            <dt>3.4.8</dt>
            <dd>
                  <ul>
                    <li>Release JSON GSTR1 Report</li>
                  </ul>
            </dd>
            <dt>3.4.7</dt>
            <dd>
                  <ul>
                    <li>New Invoice Preview Mayer</li>
                  </ul>
            </dd>
            <dt>3.4.6</dt>
            <dd>
                  <ul>
                    <li>Add TCS option for purchase</li>
                  </ul>
            </dd>
            <dt>3.4.5</dt>
            <dd>
                  <ul>
                    <li>Adjust mobile invoice</li>
                  </ul>
            </dd>
            <dt>3.4.4</dt>
            <dd>
                  <ul>
                    <li>New Invoice entry mode and bill for mobile shops</li>
                  </ul>
            </dd>
            <dt>3.4.3</dt>
            <dd>
                  <ul>
                    <li>Update GSTR Report with cess</li>
                  </ul>
            </dd>
            <dt>3.4.2</dt>
            <dd>
                  <ul>
                    <li>Introduce option to hiden brand</li>
                  </ul>
            </dd>
            <dt>3.4.1</dt>
            <dd>
                  <ul>
                    <li>Fix Specific Cess Calculation with Quantity</li>
                  </ul>
            </dd>
            <dt>3.4.0</dt>
            <dd>
                  <ul>
                    <li>Approved Cess Invoice</li>
                  </ul>
            </dd>
            <dt>3.3.99</dt>
            <dd>
                  <ul>
                    <li>Add Cess to Item Entry</li>
                    <li>Add Specific Cess</li>
                  </ul>
            </dd>
            <dt>3.3.98</dt>
            <dd>
                  <ul>
                    <li>Fix Cess Invoice</li>
                  </ul>
            </dd>
            <dt>3.3.97</dt>
            <dd>
                  <ul>
                    <li>Add cess to purchase list</li>
                    <li>Fix cess invocie preview</li>
                  </ul>
            </dd>
            <dt>3.3.96</dt>
            <dd>
                  <ul>
                    <li>Fix cess to invoice list</li>
                  </ul>
            </dd>
            <dt>3.3.95</dt>
            <dd>
                  <ul>
                    <li>Allow Cess for invoice</li>
                    <li>Allow Cess for purchase</li>

                  </ul>
            </dd>
            <dt>3.3.94</dt>
            <dd>
                  <ul>
                    <li>Minor Fixes</li>
                  </ul>
            </dd>
            <dt>3.3.93</dt>
            <dd>
                  <ul>
                    <li>Revert After tax discount</li>
                  </ul>
            </dd>
            <dt>3.3.92</dt>
            <dd>
                  <ul>
                    <li>Fix Receiptlist and Paymentlist</li>

                  </ul>
            </dd>
            <dt>3.3.91</dt>
            <dd>
                  <ul>
                    <li>Calculate Due amount including all kinds of payments & receipts</li>
                    <li>Fix client change error on add receipt page</li>
                    <li>Fix supplier change error on add payment page</li>
                  </ul>
            </dd>
            <dt>3.3.90</dt>
            <dd>
                  <ul>
                    <li>Release purchases B2B report</li>
                  </ul>
            </dd>
            <dt>3.3.89</dt>
            <dd>
                  <ul>
                    <li>Release summary for purchases</li>
                  </ul>
            </dd>
            <dt>3.3.88</dt>
            <dd>
                  <ul>
                    <li>Fix quantity input zeros purchase</li>
                  </ul>
            </dd>
            <dt>3.3.87</dt>
            <dd>
                  <ul>
                    <li>Fix quantity input</li>
                  </ul>
            </dd>
            <dt>3.3.86</dt>
            <dd>
                  <ul>
                    <li>Fix Delete for Barcode Invoice</li>
                    <li>Show entire stock value</li>
                  </ul>
            </dd>
            <dt>3.3.85</dt>
            <dd>
                  <ul>
                    <li>Fix mobile table summary</li>
                  </ul>
            </dd>
            <dt>3.3.84</dt>
            <dd>
                  <ul>
                    <li>Allow custom props for invoice a4</li>
                  </ul>
            </dd>
            <dt>3.3.83</dt>
            <dd>
                  <ul>
                    <li>Total summaries for reports</li>
                  </ul>
            </dd>
            <dt>3.3.82</dt>
            <dd>
                  <ul>
                    <li>Empty inputs for item entry</li>
                  </ul>
            </dd>

            <dt>3.3.82</dt>
            <dd>
                  <ul>
                    <li>Bug fix on add/edit unit</li>

                  </ul>
            </dd>

            <dt>3.3.81</dt>
            <dd>
                  <ul>
                    <li>Search through serial for barcode users</li>
                    <li>Stock Summation</li>
                  </ul>
            </dd>
            <dt>3.3.80</dt>
            <dd>
                  <ul>
                    <li>Update barcode invoice with percentages</li>
                    <li>New Invoice Template Thin</li>
                    <li>Provide Responsiveness for this template</li>
                  </ul>
            </dd>
            <dt>3.3.79</dt>
            <dd>
                  <ul>
                    <li>Fix Discounts</li>
                  </ul>
            </dd>
            <dt>3.3.78</dt>
            <dd>
                  <ul>
                    <li>Barcode Input</li>
                    <li>Apply Discount On Before/After Tax</li>
                    <li>Fix Trader Template</li>
                  </ul>
            </dd>
            <dt>3.3.77</dt>
            <dd>
                  <ul>
                    <li>Barcode Mode Invoice</li>
                  </ul>
            </dd>
            <dt>3.3.76</dt>
            <dd>
                  <ul>
                    <li>Replace FSSAI and DL parameters with additional params</li>
                    <li>Show discount zeros in invoice cucumber</li>
                  </ul>
            </dd>
            <dt>3.3.75</dt>
            <dd>
                  <ul>
                    <li>Release new invoice template cucumber </li>
                    <li>Allow its selection from settings </li>
                    <li>Render FSSAI and DL numbers in invoices </li>
                    <li>Bug fixes</li>
                  </ul>
            </dd>
            <dt>3.3.74</dt>
            <dd>
                  <ul>
                    <li>Uprage app to handle more decimals </li>

                  </ul>
            </dd>

            <dt>3.3.73</dt>
            <dd>
                  <ul>
                    <li>Fix Receipt invoice series name</li>

                  </ul>
            </dd>

            <dt>3.3.72</dt>
            <dd>
                  <ul>
                    <li>Auto detect IGST invoice</li>
                    <li>Add new template code</li>
                  </ul>
            </dd>

            <dt>3.3.71</dt>
            <dd>
                  <ul>
                    <li>Add Client Notes to Invoice</li>
                  </ul>
            </dd>
            <dt>3.3.70</dt>
            <dd>
                  <ul>
                    <li>Add quarterly report</li>
                  </ul>
            </dd>
          <dt>3.3.69</dt>
          <dd>
                <ul>
                  <li>Minor Enhancements</li>
                </ul>
          </dd>
          <dt>3.3.68</dt>
          <dd>
                <ul>
                  <li>Validate GSTIN</li>
                </ul>
          </dd>
          <dt>3.3.67</dt>
          <dd>
                <ul>
                  <li>Provide a separate Rate Wise Sales Report</li>
                </ul>
          </dd>
          <dt>3.3.66</dt>
          <dd>
                <ul>
                  <li>Provide a separate HSN Report </li>
                </ul>
          </dd>
          <dt>3.3.65</dt>
          <dd>
                <ul>
                  <li>Show warning if item closing purchase rate is higher than selling rate. </li>
                  <li>Purchase Round off</li>
                  <li>UI Fixes </li>
                </ul>
          </dd>
          <dt>3.3.64</dt>
          <dd>
                <ul>
                  <li>Fix invoice item create problem</li>
                </ul>
          </dd>
          <dt>3.3.63</dt>
          <dd>
                <ul>
                  <li>SearchBar for most of the pages</li>
                  <li>Save pagination state between routes</li>
                </ul>
          </dd>
          <dt>3.3.62 --- 58</dt>
          <dd>
                <ul>
                  <li>Missing Due to changes mentioned only in bitbucket</li>
                </ul>
          </dd>

          <dt>3.3.57</dt>
          <dd>
                <ul>
                  <li>Move Beta to production</li>
                </ul>
          </dd>
          <dt>3.3.56</dt>
          <dd>
                <ul>
                  <li>Add Analytics to track users</li>
                </ul>
          </dd>
          <dt>3.3.55</dt>
          <dd>
                <ul>
                  <li>Minor Enhancements</li>
                  <li>List Pricing Plans</li>
                </ul>
          </dd>
          <dt>3.3.54</dt>
          <dd>
                <ul>
                  <li>Item entry UX improvement</li>
                  <li>Composition Scheme Users Invoice</li>
                  <li>Bug fixes</li>
                </ul>
          </dd>
          <dt>3.3.53</dt>
          <dd>
                <ul>
                  <li>Default current date for invoice</li>
                  <li>Fix invoice and purchase date sort issue</li>
                  <li>Replace serieal with supplier bill number for purchse list</li>
                </ul>
          </dd>
          <dt>3.3.52</dt>
          <dd>
                <ul>
                  <li>Remove customer chat app</li>
                </ul>
          </dd>
          <dt>3.3.50 51</dt>
          <dd>
                <ul>
                  <li>Introduce Live Chat Support for all users</li>
                  <li>Introduce Configurable barcode for items</li>
                  <li>Other bug fixes</li>
                </ul>
          </dd>
          <dt>3.3.49</dt>
          <dd>
                <ul>
                  <li>Link Help documentation</li>
                </ul>
          </dd>
          <dt>3.3.49</dt>
          <dd>
                <ul>
                  <li>Optional Parameters for Invoice and Profile</li>
                </ul>
          </dd>
          <dt>3.3.48</dt>
          <dd>
                <ul>
                  <li>Allow series name to delete</li>
                </ul>
          </dd>
          <dt>3.3.47</dt>
          <dd>
                <ul>
                  <li>Fix several UI Bugs found by tester</li>
                  <li>Suggest default values for drop downs</li>
                </ul>
          </dd>
          <dt>3.3.46</dt>
          <dd>
                <ul>
                  <li>Add declaration option for Invoice</li>
                </ul>
          </dd>
          <dt>3.3.45</dt>
          <dd>
                <ul>
                  <li>Fix Trader Template</li>
                  <li>Modify column name declaration to T&C</li>
                </ul>
          </dd>
          <dt>3.3.44</dt>
          <dd>
                <ul>
                  <li>Fix Invoice Style</li>

                </ul>
          </dd>
          <dt>3.3.43</dt>
          <dd>
                <ul>
                  <li>Expenses Introduction</li>
                  <li>Avoid Modern calendar lack of support for older browsers</li>
                  <li>Include expenses in the day book</li>
                </ul>
          </dd>
          <dt>3.3.42</dt>
          <dd>
                <ul>
                  <li>Update Billing View</li>
                  <li>Minor Enhancements</li>
                  <li>Fix GSTR 1 Errors </li>
                </ul>
          </dd>
          <dt>3.3.41</dt>
          <dd>
                <ul>
                  <li>Introduce billing section</li>
                </ul>
          </dd>
          <dt>3.3.40</dt>
          <dd>
                <ul>
                  <li>Provide Roundoff for trader template</li>
                  <li>Accommodate IGST for trader template</li>
                </ul>
          </dd>
          <dt>3.3.39</dt>
          <dd>
                <ul>
                  <li>Remove Client Analytics</li>
                  <li>Improve App Load Time</li>
                  <li>Provide new invoice template (Trader Slim) for traders</li>
                </ul>
          </dd>
          <dt>3.3.38</dt>
          <dd>
                <ul>
                  <li>Show Expiry Date for items in batch mode</li>
                  <li>Configurable Expiry Date</li>
                  <li>Fix Purchase preview </li>
                  <li>Provide Pharma preview</li>
                  <li>Fix Credit note previews</li>
                  <li>Other bug fixes</li>
                </ul>
          </dd>
          <dt>3.3.37</dt>
          <dd>
                <ul>
                  <li>Font option for invoice</li>
                </ul>
          </dd>
          <dt>3.3.36</dt>
          <dd>
                <ul>
                  <li>Preview and Print Style</li>
                </ul>
          </dd>
          <dt>3.3.35</dt>
          <dd>
                <ul>
                  <li>Fix Debit Note UI</li>
                  <li>Release Debit Note Batch Mode</li>
                </ul>
          </dd>
          <dt>3.3.34</dt>
          <dd>
                <ul>
                  <li>Fix Invoice print style</li>
                </ul>
          </dd>
          <dt>3.3.33</dt>
          <dd>
                <ul>
                  <li>Purchase in Batch Mode</li>
                  <li>Code refactor for memory leaks</li>
                  <li>Remove un used imports</li>
                </ul>
          </dd>
          <dt>3.3.32</dt>
          <dd>
                <ul>
                  <li>Have pharma preview for batch mode inovices</li>
                  <li>Warnings before delete for purchase, credit etc.</li>
                  <li>Fix Daylog for payments, receipts </li>
                </ul>
          </dd>
          <dt>3.3.31</dt>
          <dd>
                <ul>
                  <li>Show negative stock </li>
                  <li>Fix Item Stock Sort</li>
                </ul>
          </dd>
          <dt>3.3.30</dt>
          <dd>
                <ul>
                  <li>Fix item create modal for invoice, purchase, client credit and Debit Note</li>
                  <li>UI Refactor</li>
                </ul>
          </dd>
          <dt>3.3.29</dt>
          <dd>
                <ul>
                  <li>Rename wrongly placed Debit notes text</li>
                  <li>Bug Fixes</li>
                </ul>
          </dd>
          <dt>3.3.28</dt>
          <dd>
                <ul>
                  <li>Bug Fixes</li>
                </ul>
          </dd>
          <dt>3.3.27</dt>
          <dd>
                <ul>
                  <li>Show stock values</li>
                  <li>Bug Fixes</li>
                </ul>
          </dd>
          <dt>3.3.27</dt>
          <dd>
                <ul>
                  <li>Track Batches for item</li>
                  <li>Sell By Batch for testing only..</li>
                </ul>
          </dd>
          <dt>3.3.26</dt>
          <dd>
                <ul>
                  <li>Date in one format for all </li>
                  <li>Release Item Batch for testers only</li>
                </ul>
          </dd>

        <dt>3.3.25</dt>
        <dd>
              <ul>
                <li>XS Screen UI enhancements </li>
                <li>Other Bug fixes</li>
              </ul>
        </dd>


      </dl>
        </div>



    </div>

  }
}



// WEBPACK FOOTER //
// ./src/components/blog/developments.js